<template>
  <section>
    <el-dialog title="订单重传详情" :visible.sync="visible" width="45%" :close-on-click-modal="false" :before-close="close">
      <div class="item">
        <div class="item_side item_title">我要订单重传</div>
        <div class="item_main">
          <el-upload
            ref="upload"
            action=""
            :on-remove="handleRemove"
            :auto-upload="false"
            :multiple="false"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          >
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <el-button style="margin-left: 10px" size="small" type="primary" :loading="excelDownloading" @click="excelDownload">下载模板</el-button>
            <el-button style="margin-left: 10px" size="small" type="success" :loading="uploadFileLoading" @click="submitUpload">上传到服务器</el-button>
            <el-button v-if="failVisible" style="margin-left: 10px" size="small" type="success" :loading="failDownloading" @click="failDownload"
              >失败原因下载</el-button
            >
            <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
          </el-upload>
        </div>
      </div>

      <div>
        <div class="item">
          <div class="item_title">重传历史记录</div>
        </div>
        <el-table
          stripe
          v-loading="listLoading"
          :data="tableData"
          :header-cell-style="{ background: '#EDF7FE' }"
          element-loading-text="使劲加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          border
          row-key="id"
        >
          <el-table-column label="序号" type="index" width="50" align="center" />
          <el-table-column prop="id" label="id" align="center" />
          <el-table-column prop="createTime" label="重传日期" align="center" />
          <el-table-column prop="auditStatus" label="审核状态" align="center" >
            <template slot-scope="scope">
              <span v-if="scope.row.auditStatus ==='00'">审核中</span>
              <span v-else-if="scope.row.auditStatus === '01'">审核通过</span>
              <span v-else-if="scope.row.auditStatus === '02'">审核拒绝</span>
            </template>
          </el-table-column>
          <el-table-column label="附件" align="center">
            <template slot-scope="scope">
              <el-button type="text" :loading="singleDownloading && singleIndex === scope.$index" @click="showDownloadDialog('single', scope.row)"
                >下载</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- 列表渲染结束 -->
        <!--分页工具条-->
        <!-- <pagination
        v-show="detailsTotal > 0"
        :total="detailsTotal"
        :page.sync="detailsPage"
        :limit.sync="detailsSize"
        :current-page="detailsPage"
        @pagination="handleDetailByPage()"
      /> -->
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="tableData.length > 0" type="primary" :loading="allDownloading" @click="showDownloadDialog('multiple')">下载全部</el-button>
        <el-button @click.native="close">取消</el-button>
      </div>
      <!-- 导出对话框 -->
      <el-dialog title="导出提示" :visible.sync="downloadVisible" width="40%" :close-on-click-modal="false" @before-close="closeDownloadDialog" append-to-body>
        <el-form label-width="120px">
          <el-form-item label="文件名称">
            <el-input v-model.trim="downloadFilename" placeholder="请输入下载文件名称" maxlength="120" @blur="check_filename($event)" clearable></el-input>
          </el-form-item>
          <el-form-item label="提示">
            <span>当前文件下载完成后，请前往跨境业务管理->文件下载页面查看。</span>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="closeDownloadDialog">取消</el-button>
          <el-button type="primary" @click="confirmDownload" :loading="downloadLoading">确定</el-button>
        </div>
      </el-dialog>
    </el-dialog>
  </section>
</template>
<script>
import { orderDownload, orderReupload, orderReuploadQuery } from '@/api/crossborder/declare/restore/restore'
import { declareTemplateDownload } from '@/api/crossborder/declare/declareCreate'
import CommonApi from '@/api/common/common'
import File from '@/utils/file'
export default {
  props: {},
  data: function () {
    return {
      visible: false,

      excelDownloading: false,
      uploadFileLoading: false,
      allDownloading: false,
      failDownloading: false,
      failVisible: false,
      errUrl: '',

      listLoading: false, // 表格的加载状态
      tableData: [],

      singleIndex: 0,
      singleDownloading: false,

      // 导出变量
      downloadType: null, // single multiple
      downloadId: null, // 如果是single的话，需要传递id
      downloadLoading: false,
      downloadVisible: false,
      downloadFilename: null,
    }
  },

  methods: {
    // 文件名称有些特殊符号不能使用，替换成''
    check_filename(event) {
      this.downloadFilename = event.target.value.replace(/[\\\\/:*?\"<>|]/g, '')
    },

    open(row) {
      console.log('我接收到row----------------', row)
      this.declareNo = row.declareNo
      this.visible = true
      this.getTableData()
    },

    close() {
      this.visible = false
      this.loading = false
      this.tableData = []
      this.uploadFileLoading = false
      this.excelDownloading = false
      this.allDownloading = false
      this.failDownloading = false 
      this.failVisible = false
      this.errUrl = ''
      this.singleDownloading = false
      this.singleIndex = 0

      this.$refs.upload.clearFiles()
    },

    getTableData() {
      this.tableData = []
      this.listLoading = true
      orderReuploadQuery({ declareNo: this.declareNo })
        .then((res) => {
          this.listLoading = false
          if (res.data) this.tableData = res.data
        })
        .catch((err) => {
          this.listLoading = false
          console.log('查询错误', err)
        })
    },

    // 模板下载，这个模板就是还原明细模板
    excelDownload() {
      this.excelDownloading = true
      declareTemplateDownload({ templateType: '01' })
        .then((res) => {
          this.excelDownloading = false
          File.output(res)
        })
        .catch((err) => {
          this.excelDownloading = false
          console.log('下载出错', err)
        })
    },

    submitUpload() {
      console.log('this.$refs.upload.uploadFiles', this.$refs.upload.uploadFiles)

      let file = (this.$refs.upload.uploadFiles.length > 0 && this.$refs.upload.uploadFiles[0].raw) || null
      if (!file) {
        this.$message.error('请先选择文件')
        return
      }
      if (file.size > 1024 * 1024 * 20) {
        this.$message.error('上传文件请小于20M')
        return
      }

      const form = new FormData() // FormData 对象
      form.append('file', file) // 文件对象  'file'是后台接收的参数名
      form.append('merNo', this.$store.getters.merNo)
      form.append('declareNo', this.declareNo)
      this.$refs.upload.uploadFiles[0].status = 'loading'
      this.uploadFileLoading = true
      orderReupload(form)
        .then((res) => {
          this.uploadFileLoading = false
          if (res.data.checkCode === '9999') {
            this.$refs.upload.uploadFiles[0].status = 'fail'
            this.errUrl = res.data.filePath
            this.failVisible = true
            this.$message.error('上传文件格式错误')
          } else {
            // this.$refs.upload.uploadFiles[0].status = 'success'
            this.$refs.upload.uploadFiles = []
            this.errUrl = ''
            this.failVisible = false
            this.$message.success('上传成功')
            this.$emit('success')
            this.close()
          }
        })
        .catch((error) => {
          this.uploadFileLoading = false
          this.$refs.upload.uploadFiles[0].status = 'fail'
          console.log(error) // 请求失败返回的数据
        })
    },

    // 失败文件下载
    failDownload() {
      this.failDownloading = true
      CommonApi.dataFileDownload({ url: this.errUrl })
        .then((res) => {
          // console.log(res)
          this.failDownloading = false
          let name = '订单明细列表-' + this.$store.getters.merNo + '.xlsx'
          if (name.startsWith('"') && name.endsWith('"')) {
            name = name.substring(1, name.length - 1)
          }
          name = decodeURI(name)
          const blob = new Blob([res.data])
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.download = name
          a.click()
          window.URL.revokeObjectURL(url)
          a.remove()
        })
        .catch((error) => {
          this.failDownloading = false
          console.log(error) // 请求失败返回的数据
        })
    },

    handleRemove(file, fileList) {
      console.log('file fileList', file, fileList)
    },

    showDownloadDialog(type, row) {
      this.downloadVisible = true
      this.downloadFilename = null
      this.downloadType = type
      if (row) {
        this.downloadId = row.id
      }
    },

    closeDownloadDialog() {
      this.downloadVisible = false
      this.downloadFilename = null
      this.downloadId = null
      this.downloadType = null
    },

    confirmDownload() {
      if(!this.downloadFilename){
        this.$message.error('请填写下载文件名称')
        return
      }
      let param
      if (this.downloadType === 'single') {
        param = {
          id: this.downloadId,
          declareNo: this.declareNo,
          recordUser: this.$store.getters.merNo,
          fileName: this.downloadFilename,
          recordType: '2',
          moduleName: '01',
        }
      } else if (this.downloadType === 'multiple') {
        param = {
          id: null,
          declareNo: this.declareNo,
          recordUser: this.$store.getters.merNo,
          fileName: this.downloadFilename,
          recordType: '2',
          moduleName: '01',
        }
      }

      this.downloadLoading = true
      orderDownload(param)
        .then((res) => {
          this.downloadLoading = false
          this.downloadFilename = null
          this.downloadVisible = false
          this.downloadId = null
          this.$message.success('处理中，请稍候前往文件下载页面查看')
          // File.output(res)
        })
        .catch((err) => {
          this.downloadLoading = false
          console.log('下载出错', err)
        })
    },

    singleDownload(index, row) {
      this.$confirm('当前文件下载完成后，请前往文件下载页面查看。请问是否需要下载文件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.singleIndex = index
          const param = {
            id: row.id,
            declareNo: this.declareNo,
            recordUser: this.$store.getters.merNo,
            recordType: '0',
            moduleName: '01',
          }
          this.singleDownloading = true
          orderDownload(param)
            .then((res) => {
              this.singleDownloading = false
              // File.output(res)
            })
            .catch((err) => {
              this.singleDownloading = false
              console.log('下载出错', err)
            })
        })
        .catch(() => {
          // 取消操作,按钮设置可用
        })
    },

    allDownload() {

      this.$confirm('当前文件下载完成后，请前往文件下载页面查看。请问是否需要下载文件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.allDownloading = true
          const param = {
            id: null,
            declareNo: this.declareNo,
            recordUser: this.$store.getters.merNo,
            recordType: '0',
            moduleName: '01',
          }
          orderDownload(param)
            .then((res) => {
              this.allDownloading = false
              // File.output(res)
            })
            .catch((err) => {
              this.allDownloading = false
              console.log('下载出错', err)
            })
        })
        .catch(() => {
          // 取消操作,按钮设置可用
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.item {
  display: flex;
  flex-direction: row;
  padding: 12px 0px;

  .item_title {
    line-height: 32px;
    text-align: right;
    font-size: 16px;
    color: #909399;
    font-weight: 600;
  }

  .item_main {
    flex: 1;
    padding: 0px 8px;
  }
}
</style>